import z from 'zod'

import { MarketSummary } from '@fortem-monorepo/web-sdk'

export const updateInstrumentSchema = z.object({
  section: z.enum(MarketSummary.SECTIONS),
  bucket: z.enum(MarketSummary.INSTRUMENT_BUCKETS).nullish(),
  sub_bucket: z.enum(MarketSummary.INSTRUMENT_SUB_BUCKETS).nullish(),
  value_type: z.enum(MarketSummary.INSTRUMENT_VALUE_TYPES),
  source_unit: z.enum(MarketSummary.INSTRUMENT_UNITS).nullish(),
  display_metric_unit: z.enum(MarketSummary.INSTRUMENT_UNITS).nullish(),
})

export const addInstrumentSchema = updateInstrumentSchema.extend({
  instrument_id: z.number().int().nonnegative(),
})

export const instrumentUnitFields = [
  { name: 'source_unit', label: 'Source Unit' },
  { name: 'display_metric_unit', label: 'Display Metric Unit' },
] as const
